// extracted by mini-css-extract-plugin
export var icon = "_9x-3";
export var subtitle = "_9x-2";
export var title = "_9x-1";
export var value = "_9x-0";